import Vue from 'vue'
import Router from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import Home from '@/views/Home.vue'
import { PROJECT_NAME, ELECTION_NAV_CONFIG } from '@/constant'

const BASE_URL = (function (projectName) {
  if (process.env.NODE_ENV !== 'production') {
    return process.env.BASE_URL
  }
  let url = window.location.pathname
  let paths = url.split('/')
  let index = paths.lastIndexOf(projectName)
  let baseUrl = (index !== -1) ? paths.slice(0, index + 1).join('/') : url
  return baseUrl
})(PROJECT_NAME)

const GA_ROOT_PATH = BASE_URL.replace(/\/$/, '')

const AVAILABLE_NAV_DATA = ELECTION_NAV_CONFIG.filter(({ disable }) => !disable)
const AVAILABLE_YEARS = AVAILABLE_NAV_DATA.map(option => option.year)
const DEFAULT_ENTRY = AVAILABLE_NAV_DATA.filter(({ defaultEntry }) => defaultEntry)[0] || null

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: BASE_URL,
  routes: [
    {
      path: '/',
      redirect: `/${!DEFAULT_ENTRY ? '2016' : DEFAULT_ENTRY.year}`
    },
    {
      path: '/:year',
      name: 'home',
      component: Home,
      props: true,
      meta: {
        transitionName: 'slide'
      },
      beforeEnter: (to, from, next) => {
        let { year = null } = to.params
        if (!year || AVAILABLE_YEARS.indexOf(year) === -1) {
          next('/')
        }
        if (year && /^\/\d{4}\/$/.test(to.path)) {
          next({
            name: 'home',
            params: { year }
          })
        }
        next()
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // if (savedPosition) {
    //   return savedPosition
    // } else {
    //   return { x: 0, y: 0 }
    // }
    return null
  }
})

router.onError(err => {
  console.log(err)
})

router.beforeEach((to, from, next) => {
  // let path = to.path.replace(/\/$/, '')
  // let articlePattern = /^\/article\/(\d+)\/?/
  // let title = '數據看選舉 | 看懂2020總統立委大選'
  // let subtitle = ''
  // if (articlePattern.test(path)) {
  //   let id = Number(path.replace(articlePattern, '$1'))
  //   if (!isNaN(id)) {
  //     let topic = topics[id - 1] || null
  //     subtitle = !topic ? '' : topic.title.replace('\n', ' ')
  //   }
  // }
  // document.title = !subtitle ? title : `${subtitle} | ${title}`

  switch (to.name) {
    case 'home':
      const y1 = Number(from.params.year) || 0
      const y2 = Number(to.params.year)
      to.meta.transitionName = y2 > y1 ? 'slide-right' : 'slide-left'
      break
    default:
  }
  return next()
})

router.beforeResolve((to, from, next) => {
  return next()
})

router.afterEach(function (to, from) {
  if (from.name !== null && from.path !== '/') {
    // scroll back to top
    setTimeout(() => VueScrollTo.scrollTo(document.body, 400), 400)
  }
  // ga record
  Vue.ga('newmedia.send', {
    'hitType': 'pageview',
    'page': `${GA_ROOT_PATH}${to.path}`,
    'title': document.title
  })
})

console.log('[vue-router] base', router.options.base)

export default router
